export const theme = {
    colors: {
        bearu_primary: "#4745FF",
        black: "#242424",
        dg1: "#595959",
        dg2: "#999999",
        dg3: "#d8d8d8",
        dg4: "#727272",
        lg3: "#d8d8d8",
        lg2: "#e8e8e8",
        lg1: "#f4f4f4",
        select: "#f2f2ff",
        w: "#ffffff",
        active_button: "#3838b7",
        context_hover: "#f2fbfb",
        tooltip: "#454444",
        play_background: "#F2F2FF",
        info_box_background: "#4390f8",
        info_title: "#f9f91d",
        info_title_numbering: "#6236ff",
    },
    font_size: {
        f12: ".6em",
        f13: ".7em",
        f14: ".8em",
        f15: ".9em",
        f16: "1em",
        f17: "1.1em",
        f18: "1.2em",
        f19: "1.3em",
        f20: "1.4em",
        f21: "1.5em",
        f22: "1.6em",
        f23: "1.7em",
        f24: "1.8em",
        f25: "1.9em",
        f26: "2em",
    },
    box_shadow: "2px 3px 12px rgba(199,199,199,0.35)",
};
